import React from "react"
import NextRouteSection from "./nextroutesection"
import RecommendItems from "./recommenditems"
import OfficialGoodsCards from "./officialgoodscards"
import FeatureHubCard from "./featurehubcard"
import SnsPostShare from "../snspostshare" // シェアボタンを別途作成済みと仮定
import * as styles from "../../styles/articlefooter.module.scss"

const ArticleFooterRecOnly = () => {
  return (
    <footer className={styles.footerWrapper}>
      {/* 1. まずは拡散してもらう */}
      <div className={styles.shareSection}>
        <SnsPostShare />
      </div>

      <hr className={styles.divider} />

      <FeatureHubCard area="ギア" />

      <RecommendItems />

      {/* 3. 公式グッズ紹介 */}
      <OfficialGoodsCards />
    </footer>
  )
}

export default ArticleFooterRecOnly
